// @flow
import React, { type Element } from 'react';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import Helmet from 'react-helmet-async';
import { analytics } from 'angieslist-app-platform';
import { defaultPageProps } from '../../../app/browser/analyticsDefaultProperties';
import type { ServiceProvider, ServiceProviderCacheState } from '../../../app/types';
import serviceProviderActions from '../../../app/common/serviceProvider/serviceProviderActions';
import ServiceProviderDashboard from './components/ServiceProviderDashboard';

type Props = {
  serviceProviderCache: ServiceProviderCacheState,
  experiment: any,
  params: {
    serviceProviderId: string
  }
};

const loader = (
  <div className="text-center">
    <i className="icon icon-load icon-spin icon-5x text-primary" />
  </div>
);

export const BusinessViewComponent = ({
  serviceProviderCache, params, experiment,
}: Props): Element<"div"> => {
  const { serviceProviderId } = params;
  const serviceProvider: ServiceProvider = serviceProviderCache[serviceProviderId];

  return (
    <div>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <Choose>
        <When condition={!serviceProvider || typeof serviceProvider.isAdvertiser === 'undefined'}>
          {/*
          This code path will only occur on a cold start when user
          navigates directly to /app/home/:serviceProviderId
          */}
          {loader}
        </When>
        <Otherwise>
          <ServiceProviderDashboard serviceProvider={serviceProvider} />
        </Otherwise>
      </Choose>
    </div>
  );
};

const businessViewAnalytics = {
  page: {
    name: 'SP : Home',
    properties: defaultPageProps,
  },
};

export default (hot(module)(compose(
  analytics({
    ruleset: businessViewAnalytics,
  }),
  connect(state => ({
    serviceProviderCache: state.serviceProviderCache,
    experiment: state.experimentV2,
  }), serviceProviderActions),
  pure,
)(BusinessViewComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/BusinessView.js